document.addEventListener('DOMContentLoaded', () => {
    // Esperar a que GSAP y ScrollTrigger estén disponibles
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('GSAP or ScrollTrigger not loaded');
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const missionVisionBlocks = document.querySelectorAll('.mission-vision-block');

    missionVisionBlocks.forEach((block) => {
        const images = block.querySelectorAll('.image-block img');
        
        images.forEach((img, index) => {
            // Configurar el estado inicial
            gsap.set(img, {
                scale: 1.2,
                transformOrigin: 'center center'
            });

            // Animación de zoom out con scroll
            gsap.to(img, {
                scale: 1,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: img.parentElement,
                    start: 'top 80%',
                    end: 'bottom 20%',
                    scrub: 1,
                    invalidateOnRefresh: true, // Recalcula posiciones si la página cambia de altura
                    // markers: true, // Descomenta para debug
                }
            });
        });

        // Animación adicional para los bloques de texto (opcional)
        const textBlocks = block.querySelectorAll('.text-block');
        textBlocks.forEach((textBlock) => {
            gsap.from(textBlock, {
                opacity: 0,
                y: 50,
                duration: 1,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: textBlock,
                    start: 'top 90%',
                    end: 'top 60%',
                    toggleActions: 'play none none reverse',
                    invalidateOnRefresh: true, // Recalcula posiciones si la página cambia de altura
                }
            });
        });
    });
});
